"use strict";

let KDBasicArmorWeight = 4.7;
let KDBasicArmorWeight_Cursed = 0.5;
let KDEnchantedRestraintsWeight = 1.0;
let KDAdvancedArmorWeight = 3;
let KDAdvancedArmorWeight_Cursed = 0.5;

let KD_hexchance_Default = 0.1;
let KD_hexscale_Default = 0.4; // based on % of max level
let KD_enchantchance_Default = 0.25;
let KD_enchantscale_Default = 1/0.7; // % of max level, ~70% of the way through all will be enchanted

let KD_hexchance_EnchantedRestraints = 0.3;
let KD_hexscale_EnchantedRestraints = 0.7;


let KDBasicArmor = [
	{name: "Swimsuit", minLevel: 0, weight: KDBasicArmorWeight*0.8,
		armor: "Swimsuit",
		cursesuffix: "Common",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["Swimsuit"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "SwimsuitMimic", minLevel: 0, weight: KDBasicArmorWeight*0.5,
		armor: "Swimsuit",
		cursesuffix: "Mimic",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["Swimsuit"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "Breastplate", minLevel: 0, weight: KDBasicArmorWeight*0.7,
		armor: "Breastplate",
		cursesuffix: "Mimic",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["Breastplate"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "BreastplateShibari", minLevel: 0, weight: KDBasicArmorWeight*0.3,
		armor: "Breastplate",
		cursesuffix: "Shibari",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["Breastplate"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "Bustier", minLevel: 0, weight: KDBasicArmorWeight*0.7,
		armor: "Bustier",
		cursesuffix: "Mimic",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["Bustier"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "BustierShibari", minLevel: 0, weight: KDBasicArmorWeight*0.4,
		armor: "Bustier",
		cursesuffix: "Shibari",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["Bustier"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "ChainTunic", minLevel: 0, weight: KDBasicArmorWeight * 0.5,
		armor: "ChainTunic",
		cursesuffix: "Mimic",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["ChainTunic"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "ChainTunicShibari", minLevel: 0, weight: KDBasicArmorWeight * 0.25,
		armor: "ChainTunic",
		cursesuffix: "Shibari",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["ChainTunic"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "ChainTunicSkimpy", minLevel: 0, weight: KDBasicArmorWeight * 0.3,
		armor: "ChainTunic",
		cursesuffix: "Skimpy",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["ChainTunic"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "ChainBikini", minLevel: 0, weight: KDBasicArmorWeight * 0.7,
		armor: "ChainBikini",
		cursesuffix: "Mimic",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["ChainBikini"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "ChainBikiniShibari", minLevel: 0, weight: KDBasicArmorWeight * 0.3,
		armor: "ChainBikini",
		cursesuffix: "Shibari",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["ChainBikini"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "Bracers", minLevel: 0, weight: KDBasicArmorWeight*0.7,
		armor: "Bracers",
		cursesuffix: "Mimic",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["Bracers"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "BracersShibari", minLevel: 0, weight: KDBasicArmorWeight*0.5,
		armor: "Bracers",
		cursesuffix: "Shibari",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["Bracers"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "LeatherGloves", minLevel: 0, weight: KDBasicArmorWeight,
		armor: "LeatherGloves",
		cursesuffix: "Mimic",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["LeatherGloves"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "Gauntlets", minLevel: 0, weight: KDBasicArmorWeight,
		armor: "Gauntlets",
		cursesuffix: "Mimic",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["Gauntlets"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "SteelBoots", minLevel: 0, weight: KDBasicArmorWeight,
		armor: "SteelBoots",
		cursesuffix: "Mimic",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["SteelBoots"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "LeatherBoots", minLevel: 0, weight: KDBasicArmorWeight,
		armor: "LeatherBoots",
		cursesuffix: "Mimic",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["LeatherBoots"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "SteelSkirt2", minLevel: 0, weight: KDBasicArmorWeight*0.6,
		armor: "SteelSkirt2",
		hexlist: "Common",
		cursesuffix: "Mimic",
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["SteelSkirt2"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "SteelSkirt2Skimpy", minLevel: 0, weight: KDBasicArmorWeight*0.4,
		armor: "SteelSkirt2",
		hexlist: "Common",
		cursesuffix: "Skimpy",
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["SteelSkirt2"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
];
let KDAdvancedArmor = [
	{name: "SteelArmor", minLevel: 0, weight: KDAdvancedArmorWeight,
		armor: "SteelArmor",
		cursesuffix: "Mimic",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["SteelArmor"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "SteelArmorShibari", minLevel: 0, weight: KDAdvancedArmorWeight,
		armor: "SteelArmor",
		cursesuffix: "Shibari",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["SteelArmor"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "SteelSkirt", minLevel: 0, weight: KDAdvancedArmorWeight*0.5,
		armor: "SteelSkirt",
		hexlist: "Common",
		cursesuffix: "Mimic",
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["SteelSkirt"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "SteelSkirtSkimpy", minLevel: 0, weight: KDAdvancedArmorWeight*0.5,
		armor: "SteelSkirt",
		hexlist: "Common",
		cursesuffix: "Skimpy",
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["SteelSkirt"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "MageArmor", minLevel: 0, weight: KDAdvancedArmorWeight,
		armor: "MageArmor",
		cursesuffix: "Mimic",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["MageArmor"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "MageArmorShibari", minLevel: 0, weight: KDAdvancedArmorWeight,
		armor: "MageArmor",
		cursesuffix: "Shibari",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["MageArmor"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

	{name: "Cape", minLevel: 0, weight: KDAdvancedArmorWeight,
		armor: "Cape",
		cursesuffix: "Mimic",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["Cape"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "CapeShibari", minLevel: 0, weight: KDAdvancedArmorWeight,
		armor: "Cape",
		cursesuffix: "Shibari",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["Cape"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

	{name: "MagicArmbandsMimic", minLevel: 0, weight: KDAdvancedArmorWeight*0.5,
		armor: "MagicArmbands",
		cursesuffix: "Mimic",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["MagicArmbands"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

	{name: "MagicArmbands", minLevel: 0, weight: KDAdvancedArmorWeight*0.8,
		armor: "MagicArmbands",
		cursesuffix: "Common",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_Default, enchantchance: KD_enchantchance_Default, alwaysenchanthex: true,
		hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		nouncursed: ["MagicArmbands"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

];
let KDGoldArmor = [...JSON.parse(JSON.stringify(KDAdvancedArmor)), ...JSON.parse(JSON.stringify(KDBasicArmor))];
for (let armor of KDGoldArmor) {
	armor.enchantlist = "Gold";
	armor.enchantchance = 1.0;
	armor.amtMult = 2;
	armor.weight *= 0.2;
}
let KDGoldArmor2 = [...JSON.parse(JSON.stringify(KDAdvancedArmor)), ...JSON.parse(JSON.stringify(KDBasicArmor))];
for (let armor of KDGoldArmor2) {
	armor.enchantlist = "Common";
	armor.enchantchance = 1.0;
	armor.minEnchants = 2;
	armor.maxEnchants = 3;
	armor.amtMult = 1.5;
	armor.weight *= 0.2;
}

let KDGoldArmorGoddess = [...JSON.parse(JSON.stringify(KDAdvancedArmor)), ...JSON.parse(JSON.stringify(KDBasicArmor))];
for (let armor of KDGoldArmorGoddess) {
	armor.enchantlist = "Gold";
	armor.enchantchance = 1.0;
	armor.minEnchants = 2;
	armor.maxEnchants = 3;
	armor.amtMult = 2;
	armor.weight *= 0.2;
	armor.hexchance *= 2;
	armor.unlockcurse = ["Divine"];
	if (armor.cursesuffix == "Mimic")
		armor.cursesuffix = "MimicHoly";
}
let KDGoldArmor2Goddess = [...JSON.parse(JSON.stringify(KDAdvancedArmor)), ...JSON.parse(JSON.stringify(KDBasicArmor))];
for (let armor of KDGoldArmor2Goddess) {
	armor.enchantlist = "Common";
	armor.enchantchance = 1.0;
	armor.minEnchants = 3;
	armor.maxEnchants = 4;
	armor.amtMult = 1.5;
	armor.weight *= 0.2;
	armor.hexchance *= 2;
	armor.unlockcurse = ["Divine"];
	if (armor.cursesuffix == "Mimic")
		armor.cursesuffix = "MimicHoly";
}
let KDSilverArmor = [...JSON.parse(JSON.stringify(KDBasicArmor))];
for (let armor of KDSilverArmor) {
	armor.amtMult = 1.4;
	armor.maxEnchants = 2;
	armor.enchantchance =(armor.enchantchance || 0) * 2;
	armor.enchantscale = (armor.enchantscale || 0) * 2;
}


let KDEnchantedRestraints = [
	{name: "TrapRestraints", minLevel: 0, weight: KDEnchantedRestraintsWeight*2,
		armortags: ["trap"], armor: "TrapGag", // Backup to a gag
		cursesuffix: "",
		maxEnchants: 2,
		faction: "Curse",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_EnchantedRestraints, enchantchance: 1, alwaysenchanthex: true,
		hexscale: KD_hexscale_EnchantedRestraints,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "SteelRestraints", minLevel: 0, weight: KDEnchantedRestraintsWeight*1,
		armortags: ["steelbondage"], armor: "TrapYoke", // Backup to a gag
		cursesuffix: "",
		maxEnchants: 3,
		amtMult: 1.3,
		faction: "Curse",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_EnchantedRestraints, enchantchance: 1, alwaysenchanthex: true,
		hexscale: KD_hexscale_EnchantedRestraints,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "LatexRestraints", minLevel: 0, weight: KDEnchantedRestraintsWeight*2.5,
		armortags: ["latexRestraintsHeavy", "latexpetsuit", "latexRestraints"], armor: "LatexBallGag",
		cursesuffix: "",
		amtMult: 1.5,
		maxEnchants: 2,
		faction: "Curse",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_EnchantedRestraints, enchantchance: 1, alwaysenchanthex: true,
		hexscale: KD_hexscale_EnchantedRestraints,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "LeatherRestraints", minLevel: 0, weight: KDEnchantedRestraintsWeight*3,
		armortags: ["leatherRestraintsHeavy"], armor: "TrapGag",
		cursesuffix: "",
		amtMult: 1.5,
		maxEnchants: 2,
		faction: "Curse",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_EnchantedRestraints, enchantchance: 1, alwaysenchanthex: true,
		hexscale: KD_hexscale_EnchantedRestraints,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "MagicRopes", minLevel: 0, weight: KDEnchantedRestraintsWeight*0.25,
		armortags: ["weakMagicRopes"], armor: "TrapGag",
		cursesuffix: "",
		amtMult: 2.5,
		faction: "Curse",
		hexlist: "Common", enchantlist: "Common", hexchance: 1.0, enchantchance: 1, alwaysenchanthex: true,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
];

let KDShadowRestraints = [...JSON.parse(JSON.stringify(KDEnchantedRestraints)),
	{name: "CursedToys", minLevel: 0, weight: KDEnchantedRestraintsWeight*1,
		armortags: ["genericToys", "plugSpell"], armor: "SteelPlugF",
		arousalMode: true,
		amtMult: 2,
		forceEquip: true,
		cursesuffix: "",
		faction: "Curse",
		hexlist: "Common", enchantlist: "Common", hexchance: 1.0, enchantchance: 1, alwaysenchanthex: true,
		unlockcurse: ["Common"],
		message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "Moon", minLevel: 0, weight: KDEnchantedRestraintsWeight*1,
		armortags: ["shadowLatexRestraints", "shadowLatexRestraintsHeavy", "shadowLatexPetsuit", "obsidianRestraints"], armor: "SteelPlugF",
		arousalMode: true,
		amtMult: 1.5,
		maxEnchants: 3,
		forceEquip: true,
		cursesuffix: "",
		faction: "Curse",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_EnchantedRestraints, enchantchance: 1, alwaysenchanthex: true,
		hexscale: KD_hexscale_EnchantedRestraints,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	{name: "Star", minLevel: 0, weight: KDEnchantedRestraintsWeight*1,
		armortags: ["liquidMetalRestraintsRandom", "shadowLatexRestraintsHeavy", "shadowLatexPetsuit", "mithrilRestraints"], armor: "SteelPlugF",
		arousalMode: true,
		amtMult: 1.5,
		maxEnchants: 3,
		forceEquip: true,
		cursesuffix: "",
		faction: "Curse",
		hexlist: "Common", enchantlist: "Common", hexchance: KD_hexchance_EnchantedRestraints, enchantchance: 1, alwaysenchanthex: true,
		hexscale: KD_hexscale_EnchantedRestraints,
		unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
		message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

];
for (let armor of KDShadowRestraints) {
	armor.amtMult = (armor.amtMult || 1) * 2.25;
	armor.maxEnchants = (armor.maxEnchants || 1) + 1;
	armor.forceEquip = true;
}



let KinkyDungeonLootTable = {
	"rubble": [
		//{name: "nothing", minLevel: 0, weight:9, message:"LootRubbleFail", messageColor:"#aaaaaa", messageTime: 2, allFloors: true},
		{name: "smallgold", minLevel: 0, weight:5, message:"LootRubbleSmallGold", messageColor:"yellow", messageTime: 3, allFloors: true},
		{name: "pick", minLevel: 0, weight:2.5, message:"LootRubbleLockpick", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true, prerequisites: ["fewpick"],},
		{name: "redkey", key: true, minLevel: 0, weight:0.8, message:"LootRubbleRedKey", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true},
		//{name: "greenkey", minLevel: 2, weight:2, message:"LootRubbleGreenKey", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true},
		//{name: "bluekey", key: true, minLevel: 2, weight:0.33, message:"LootRubbleBlueKey", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true},
		{name: "potion_mana", minLevel: 0, weight:2, message:"LootPotionMana", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "potion_will", minLevel: 0, weight:1, message:"LootPotionWill", messageColor:"#ff4444", messageTime: 3, allFloors: true},
		{name: "potion_stamina", minLevel: 0, weight:1, message:"LootPotionStamina", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true},
		{name: "potion_frigid", minLevel: 0, weight:1, message:"LootPotionFrigid", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true},


		{name: "AncientCoreSingle", minLevel: 0, weight:0.1, count: 1, message:"LootChestAncientCoreSingle", messageColor:"yellow", messageTime: 3, allFloors: true},
		{name: "AncientCoreSingleSpent", minLevel: 0, weight:1.5, count: 1, message:"LootChestAncientCoreSingleSpent", messageColor:"yellow", messageTime: 3, allFloors: true},

		{name: "Rock", minLevel: 0, weapon: "Rock", weight:10, message:"LootChestWeapon", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true, noweapon: ["Rock"]},
		{name: "knife", minLevel: 0, weight:5, message:"LootRubbleKnife", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true, noweapon: ["Knife"]},
		{name: "Torch", minLevel: 0, weight:7, weapon: "Torch", noweapon: ["Torch"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Rope", minLevel: 0, weight:8, weapon: "Rope", noweapon: ["Rope"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Scissors", minLevel: 0, weight:5, weapon: "Scissors", noweapon: ["Scissors"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "BagOfGoodies", arousalMode: true, minLevel: 0, weight:1.0, weapon: "BagOfGoodies", noweapon: ["BagOfGoodies"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	],
	"shelf": [
		{name: "ArcaneCrystal", minLevel: 5, weight:5, weapon: "ArcaneCrystal",
			noweapon: ["ArcaneCrystal"], message:"LootChestWeapon",
			messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "redkey", key: true, minLevel: 1, weight:1, message:"LootBookshelfKey", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true},
		{name: "bluekey", key: true, minLevel: 0, weight:0.33, message:"LootBookshelfBlueKey", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true},
		{name: "scroll_arms", minLevel: 0, weight:1, message:"LootBookshelfScroll", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "scroll_legs", minLevel: 0, weight:1, message:"LootBookshelfScroll", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "scroll_verbal", minLevel: 0, weight:1, message:"LootBookshelfScroll", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "trap_book", minLevel: 1, weight:5, message:"LootBookshelfTrap", messageColor:KDBaseRed, messageTime: 3, allFloors: true},
		{name: "ArcaneTome", minLevel: 0, weapon: "ArcaneTome", weight:1, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["ArcaneTome"]},
		{name: "BondageTome", minLevel: 0, weapon: "BondageTome", weight:2, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["BondageTome"]},
	],
	"pearl": [
		{name: "pearlReward", minLevel: 0, weight:1, message:"LootPearlChest", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, prerequisites: ["pearlChest"],},
	],
	"shadow": [
		{name: "ArcaneCrystal", minLevel: 5, weight:3, weapon: "ArcaneCrystal",
			noweapon: ["ArcaneCrystal"], message:"LootChestWeapon",
			messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "slimeThrower", minLevel: 0, weapon: "Slimethrower", weight:2, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["Slimethrower"]},
		{name: "StaffDoll", minLevel: 0, weapon: "StaffDoll", weight:2, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["StaffDoll"]},
		{name: "staff_incineration", minLevel: 0, weight:.5, weapon: "StaffIncineration", message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["StaffIncineration"]},
		{name: "staff_storms", minLevel: 0, weight:.5, weapon: "StaffStorm", message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["StaffStorm"]},
		{name: "staff_frostbite", minLevel: 0, weight:.5, weapon: "StaffFrostbite", message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["StaffFrostbite"]},
		{name: "staff_bind", minLevel: 0, weight:.5, weapon: "StaffBind", message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["StaffBind"]},
		{name: "AncientCores", minLevel: 0, weight:0.5, message:"LootChestAncientCores", messageColor:"yellow", messageTime: 3, allFloors: true, max: 1},
		{name: "bluekey", minLevel: 0, weight:0.5, message:"LootChestBlueKey", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		//{name: "spell_points", magic: true, minLevel: 0, weight:5, message:"LootChestSpellPoints", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, max: 1},
		...KDShadowRestraints,
	],
	"kitty": [
		{name: "CursedPetsuit", minLevel: 0, weight: 10,
			armor: "KittyPetSuit",
			amtMult: 4,
			maxEnchants: 3,
			//forceEquip: true,
			cursesuffix: "",
			prerequisites: ["nopetsuit"],
			faction: "Bast",
			hexlist: "Common", enchantlist: "Common", hexchance: 0.25, enchantchance: 1, alwaysenchanthex: true,
			hexscale: 0.75,
			unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
			message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "staff_incineration", minLevel: 0, weight:4, weapon: "StaffIncineration", message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["StaffIncineration"]},
		{name: "StaffBind", minLevel: 0, weight:4, weapon: "StaffBind", goddess: "Rope", goddessWeight: 2.75, noweapon: ["StaffBind"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "MistressKey", minLevel: 0, weight:1, message:"LootChestMistressKey", messageColor:"yellow", messageTime: 3, allFloors: true},
		{name: "grinder", minLevel: 1, weight:4, message:"LootChestGrinder", messageColor:"yellow", messageTime: 3, allFloors: true},
		{name: "AncientCores", max: 1, minLevel: 0, weight:1, count: 3, message:"LootChestAncientCores", messageColor:"yellow", messageTime: 3, allFloors: true, submissive: 50},
	],
	"robot": [
		{name: "Slimethrower", minLevel: 0, weight:4, weapon: "Slimethrower", noweapon: ["Slimethrower"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "EscortDrone", minLevel: 0, weight:4, weapon: "EscortDrone", noweapon: ["EscortDrone"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Blaster", minLevel: 0, weight:4, weapon: "Blaster", noweapon: ["Blaster"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "AncientCores", max: 1, minLevel: 0, weight:8, count: 3, message:"LootChestAncientCores", messageColor:"yellow", messageTime: 3, allFloors: true, submissive: 50},
		{name: "grinder", minLevel: 0, weight:3, message:"LootChestGrinder", messageColor:"yellow", messageTime: 3, allFloors: true},
		{name: "StormBreaker", minLevel: 0, weight:3, weapon: "StormBreaker", goddess: "Elements", goddessWeight: 3, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["StormBreaker"]},
		{name: "IceBreaker", minLevel: 0, weight:3, weapon: "IceBreaker", goddess: "Elements", goddessWeight: 3, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["IceBreaker"]},
		{name: "DivineTear", minLevel: 0, weight:0.1, message:"LootChestDivineTear", messageColor:"yellow", messageTime: 3, allFloors: true},
		{name: "MistressKey", minLevel: 0, weight:0.1, message:"LootChestMistressKey", messageColor:"yellow", messageTime: 3, allFloors: true},
	],
	"lessershadow": [
		{name: "ArcaneCrystal", minLevel: 5, weight:3, weapon: "ArcaneCrystal",
			noweapon: ["ArcaneCrystal"], message:"LootChestWeapon",
			messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		//{name: "AncientCores", minLevel: 0, weight:1.5, message:"LootChestAncientCores", messageColor:"yellow", messageTime: 3, allFloors: true, max: 1},
		//{name: "bluekey", minLevel: 0, weight:1.0, message:"LootChestBlueKey", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "pick", minLevel: 0, weight:2.5, message:"LootRubbleLockpick", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true, prerequisites: ["fewpick"],},
		//{name: "redkey", key: true, minLevel: 0, weight:1, message:"LootRubbleRedKey", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true},
		{name: "potions_many", minLevel: 0, weight:3, message:"LootPotionsMedley", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, prerequisites: ["lowpotions"]},
		{name: "magicknife", minLevel: 0, weight:1.5, weapon: "EnchKnife", message:"LootChestMagicKnife", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["EnchKnife"]},
		...KDShadowRestraints,
	],
	"storage": [
		{name: "redkey", key: true, minLevel: 0, weight:1, message:"LootChestRedKey", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true},
		{name: "bola", minLevel: 0, weight:3, message:"LootChestBola", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true},
		{name: "bomb", minLevel: 0, weight:2, message:"LootChestBomb", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true},
		{name: "gunpowder", minLevel: 0, weight:8, message:"LootChestGunpowder", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true},
		{name: "rope", minLevel: 0, weight:1, weapon: "Rope", message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["Rope"]},
	],
	"kinky": [
		{name: "Trap", minLevel: 0, weight: 10,
			count: 4,
			armortags: ["trap", "leatherRestraints", "leatherRestraintsHeavy"], armor: "TrapGag", // Backup to a gag
			faction: "Jail",
			message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Latex", minLevel: 0, weight: 10,
			count: 4,
			armortags: ["latexRestraintsHeavy", "latexpetsuit", "latexRestraints"], armor: "TrapGag", // Backup to a gag
			faction: "Jail",
			message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "CommonToy", weaponlist: "CommonToy", minLevel: 0, weight:1,
			message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "rope", minLevel: 0, weight:1, weapon: "Rope", message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["Rope"]},
	],
	"blue": [
		{name: "spell_points", magic: true, minLevel: 0, weight:1, message:"LootChestSpellPoints", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, max: 1},
	],
	"tutorial1": [
		{name: "trap_cuffs", minLevel: 0, weight:1, lock: "Red", message:"LootChestTrapMagic", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemArms"], power: 2},
	],
	"tutorial2": [
		{name: "trap_armbinder", minLevel: 0, weight:1, message:"LootChestTrapMagic", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemArms"], power: 6},
	],
	"magicWeapon": [
		{name: "CommonWeapon", weaponlist: "CommonWeapon", enchantlist: "CommonWeapon", enchantchance: 1.0, minLevel: 0, weight:1, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "CommonToy", weaponlist: "CommonToy", enchantlist: "CommonWeapon", enchantchance: 1.0, minLevel: 0, weight:1, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	],
	"pair": [
		{name: "BindingDress", minLevel: 0, weight: 10,
			armor: "BindingDress",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0, cursescale: 0,
			cursesuffix: "",
			enchantlist: "Pair", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	],
	"gendmgtest": [
		{name: "TrapRestraints", minLevel: 0, weight: KDEnchantedRestraintsWeight*2,
			armortags: ["trap"], armor: "TrapGag", // Backup to a gag
			cursesuffix: "",
			maxEnchants: 2,
			faction: "Curse",
			hexlist: "Common", enchantlist: "GenDmg", hexchance: KD_hexchance_EnchantedRestraints, enchantchance: 1, alwaysenchanthex: true,
			hexscale: KD_hexscale_EnchantedRestraints,
			unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 10, enchantlevelmin: 0, enchantlevelmax: 10,
			message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	],
	// TODO make it so that it wont try to give you a non enchanted weapon you already have
	/*"weapon": [
		{name: "CommonWeapon", weaponlist: "CommonWeapon", enchantlist: "CommonWeapon", enchantchance: KD_enchantchance_Default, enchantscale: KD_enchantscale_Default,
			minLevel: 0, weight:1, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "CommonToy", weaponlist: "CommonToy", enchantlist: "CommonWeapon", enchantchance: KD_enchantchance_Default, enchantscale: KD_enchantscale_Default,
			minLevel: 0, weight:1, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	],*/
	"chest": [

		{name: "ArrowFireSpell", spell: "ArrowFireSpell", nospell: ["ArrowFireSpell"], minLevel: 0, weight: 1.25, message:"LootChestSpell", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, prerequisites: ["hasBow"]},
		{name: "ArrowVineSpell", spell: "ArrowVineSpell", nospell: ["ArrowVineSpell"], minLevel: 0, weight: 1.25, message:"LootChestSpell", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, prerequisites: ["hasBow"]},

		{name: "archerykit", minLevel: 0, weight: 4, noweapon: ["Bow"], message:"LootArcheryKit", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "gold", minLevel: 0, weight:1, message:"LootChestGold", messageColor:"#e7cf1a", messageTime: 3, allFloors: true},
		{name: "magicknife", minLevel: 0, weight:1.5, weapon: "EnchKnife", message:"LootChestMagicKnife", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["EnchKnife"]},
		{name: "bluekey", redspecial: 8.5, key: true, minLevel: 3, weight:0.65, message:"LootChestBlueKey", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true},
		{name: "weapon_boltcutters", minLevel: 5, weight:0.7, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["BoltCutters"]},
		{name: "hammer", minLevel: 0, weight:1, weapon: "Hammer", noweapon: ["Hammer"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Maul", minLevel: 0, weight:1, weapon: "Maul", noweapon: ["Maul"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "flail", minLevel: 0, weight:1, weapon: "Flail", noweapon: ["Flail"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "axe", minLevel: 0, weight:1, weapon: "Axe", noweapon: ["Axe"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "spear", minLevel: 0, weight:1, weapon: "Spear", noweapon: ["Spear"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "ShieldTower", minLevel: 0, weight:1.5, weapon: "ShieldTower", noweapon: ["ShieldTower"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "ShieldReinforced", minLevel: 0, weight:1.0, weapon: "ShieldReinforced", noweapon: ["ShieldReinforced"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "ShieldMagic", minLevel: 0, weight:1.0, weapon: "ShieldMagic", noweapon: ["ShieldMagic"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		//{name: "sword", minLevel: 0, weight:1, weapon: "Sword", noweapon: ["Sword"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "SlimeSword", minLevel: 0, weight:1, weapon: "SlimeSword", noweapon: ["SlimeSword"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "ChainSword", minLevel: 0, weight:1, weapon: "ChainSword", noweapon: ["ChainSword"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Dirk", minLevel: 0, weight:1, weapon: "Dirk", noweapon: ["Dirk"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Foil", minLevel: 0, weight:0.5, weapon: "Foil", noweapon: ["Foil"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Crossbow", minLevel: 0, weight:1.5, weapon: "Crossbow", noweapon: ["Crossbow"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "BagOfGoodies", arousalMode: true, minLevel: 0, weight:0.5, weapon: "BagOfGoodies", noweapon: ["BagOfGoodies"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "VibeRemote", arousalMode: true, minLevel: 0, weight:0.5, weapon: "VibeRemote", noweapon: ["VibeRemote"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		...KDBasicArmor,
		{name: "MagicWeapon", weaponlist: "CommonWeapon", enchantlist: "CommonWeapon", enchantchance: 1.0, minLevel: 0, weight:2, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "MagicToy", weaponlist: "CommonToy", enchantlist: "CommonWeapon", enchantchance: 1.0, minLevel: 0, weight:2, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		/*{name: "trap_armbinder", trap: true, minLevel: 1, weight:2, message:"LootChestTrapMagic", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemArms", "ModerateRestraint"], power: 6},
		{name: "trap_armbinderHeavy", minLevel: 1, weight:2, message:"LootChestTrapMagicHarness", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemArms", "ModerateRestraint"], submissive: 15, power: 8},
		{name: "trap_cuffs", trap: true, minLevel: 1, weight:1, message:"LootChestTrapMagic", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemArms"], power: 2},
		{name: "trap_harness", trap: true, minLevel: 1, weight:2, message:"LootChestTrapMagic", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemTorso"], power: 4},
		{name: "trap_gag", trap: true, minLevel: 1, weight:3, message:"LootChestTrapMagic", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemMouth"], power: 6},
		{name: "trap_blindfold", trap: true, minLevel: 1, weight:2, message:"LootChestTrapMagic", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemHead"], power: 6},
		{name: "trap_boots", trap: true, minLevel: 1, weight:1.5, message:"LootChestTrapMagic", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemBoots"], power: 6},
		{name: "trap_legirons", trap: true, minLevel: 1, weight:1, message:"LootChestTrapMagic", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemFeet"], power: 8},
		{name: "trap_beltonly", arousalMode: true, trap: true, minLevel: 1, weight:3, message:"LootChestTrapMagicBelt", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemPelvis"], power: 5},
		{name: "trap_belt", arousalMode: true, trap: true, minLevel: 1, weight:1.5, message:"LootChestTrapMagicVibe", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemVulvaPiercings", "alreadyBelted", "vibe"], power: 1},
		*/
		{name: "trap_plug", notag: ["SupremeBelt", "NoBelt"], arousalMode: true, trap: true, minLevel: 1, weight:1.5, message:"LootChestTrapMagicPlug", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemVulva", "alreadyBelted", "vibe"], power: 3},
		{name: "trap_nipple", notag: ["SupremeBra", "FreeBoob"], arousalMode: true, trap: true, minLevel: 1, weight:1.5, message:"LootChestTrapMagicNipple", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemNipples", "alreadyBelted", "vibe"], power: 3},
		//{name: "trap_mitts", trap: true, minLevel: 7, weight:2, message:"LootChestTrapMagic", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemHands", "LightRestraint"], power: 10},
		{name: "potions_mana", minLevel: 0, weight:1, message:"LootPotionsMana", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, prerequisites: ["lowmanapotions"]},
		{name: "manaorb", minLevel: 0, weight:0.25, message:"LootManaOrb", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "potions_will", minLevel: 0, weight:1, message:"LootPotionsWill", messageColor:"#ff4444", messageTime: 3, allFloors: true, prerequisites: ["lowwillpotions"]},
		//{name: "potions_many", minLevel: 1, weight:0.5, message:"LootPotionsMedley", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, prerequisites: ["lowpotions"]},
	],
	"lost_items": [
		{name: "lost_items", minLevel: 0, weight:999999999999, message:"LootCacheLostItems", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true, prerequisites: ["LostItems"]},
	],
	"lost_clothes": [
		{name: "lost_clothes", minLevel: 0, weight:999999999999, message:"LootCacheLostClothes", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true},
	],
	"cache": [
		//{name: "lost_items", minLevel: 0, weight:999999999999, message:"LootCacheLostItems", messageColor:KDBaseLightGreen, messageTime: 3, allFloors: true, prerequisites: ["LostItems"]},
		{name: "potions_many", minLevel: 0, weight:0.001, message:"LootPotionsMedley", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "weapon_boltcutters", minLevel: 2, weight:1, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["BoltCutters"]},
		{name: "flamberge", minLevel: 3, weight:0.8, weapon: "Flamberge", noweapon: ["Flamberge"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "FrostSword", minLevel: 3, weight:0.8, weapon: "FrostSword", noweapon: ["FrostSword"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Rapier", minLevel: 3, weight:0.8, weapon: "Rapier", noweapon: ["Rapier"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Katana", minLevel: 3, weight:0.8, weapon: "Katana", noweapon: ["Katana"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "CrossbowHeavy", minLevel: 5, weight:0.8, weapon: "CrossbowHeavy", noweapon: ["CrossbowHeavy"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Longbow", minLevel: 3, weight:0.8, weapon: "Longbow", noweapon: ["Longbow"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "StaffTape", minLevel: 0, weight:1, weapon: "StaffTape", noweapon: ["StaffTape"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "DildoBatPlus", minLevel: 0, weight:1.0, weapon: "DildoBatPlus", noweapon: ["DildoBatPlus"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "StaffFlame", minLevel: 0, weight:1, weapon: "StaffFlame", noweapon: ["StaffFlame"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "StaffChain", minLevel: 0, weight:1, weapon: "StaffChain", noweapon: ["StaffChain"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "StaffGlue", minLevel: 0, weight:1, weapon: "StaffGlue", noweapon: ["StaffGlue"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "StaffElectric", minLevel: 0, weight:1, weapon: "StaffElectric", noweapon: ["StaffElectric"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "StaffPermafrost", minLevel: 0, weight:1, weapon: "StaffPermafrost", noweapon: ["StaffPermafrost"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "StaffDoll", minLevel: 5, weight:0.25, weapon: "StaffDoll", goddess: "Latex", goddessWeight: 1.25, noweapon: ["StaffDoll"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "StaffIncineration", minLevel: 5, weight:1, weapon: "StaffIncineration", goddess: "Elements", goddessWeight: 0.75, noweapon: ["StaffIncineration"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "StaffStorm", minLevel: 5, weight:1, weapon: "StaffStorm", goddess: "Elements", goddessWeight: 0.75, noweapon: ["StaffStorm"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "StaffFrostbite", minLevel: 5, weight:1, weapon: "StaffFrostbite", goddess: "Elements", goddessWeight: 0.75, noweapon: ["StaffFrostbite"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "StaffBind", minLevel: 5, weight:1, weapon: "StaffBind", goddess: "Rope", goddessWeight: 2.75, noweapon: ["StaffBind"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "Slimethrower", minLevel: 5, weight:1, weapon: "Slimethrower", goddess: "Latex", goddessWeight: 1.25, noweapon: ["Slimethrower"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		...KDAdvancedArmor,
		...KDEnchantedRestraints,
	],
	"magicrestraint": [
		...KDEnchantedRestraints,
	],
	"wizard": [

		{name: "EssenceNecklace", minLevel: 1, weight:4, message:"LootEssenceNecklace",
			armor: "EssenceNecklace",
			messageColor:"yellow", messageTime: 3, allFloors: true, norestraint: ["EssenceNecklace"]},
		{name: "ArcaneCrystal", minLevel: 5, weight:3, weapon: "ArcaneCrystal",
			noweapon: ["ArcaneCrystal"], message:"LootChestWeapon",
			messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "spell_illusion_low", magic: true, minLevel: 0, weight: 0.75, message:"LootChestSpell", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, prerequisites: ["UnlearnedIllusion", "lowlevel"]}, // lowlevel is spell levels 1-2
		{name: "spell_conjuration_low", magic: true, minLevel: 0, weight: 0.75, message:"LootChestSpell", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, prerequisites: ["UnlearnedConjure", "lowlevel"]}, // lowlevel is spell levels 1-2
		{name: "spell_elemental_low", magic: true, minLevel: 0, weight: 0.75, message:"LootChestSpell", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, prerequisites: ["UnlearnedElements", "lowlevel"]}, // lowlevel is spell levels 1-2
		{name: "MageArmor", minLevel: 0, weight: 5,
			armor: "MageArmor",
			hexlist: "Common", enchantlist: "Gold", hexchance: KD_hexchance_Default/2, enchantchance: 1.0, alwaysenchanthex: true,
			hexscale: KD_hexscale_Default, enchantscale: KD_enchantscale_Default,
			maxEnchants: 3,
			minEnchants: 2,
			unlockcurse: ["Common"], hexlevelmin: 0, hexlevelmax: 30, enchantlevelmin: 0, enchantlevelmax: 30,
			nouncursed: ["MageArmor"], message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
	],
	"gold": [
		{name: "MistressKey", minLevel: 0, weight:6, message:"LootChestMistressKey", messageColor:"yellow", messageTime: 3, allFloors: true},
		{name: "AncientCores", max: 1, minLevel: 0, weight:7, count: 3, message:"LootChestAncientCores", messageColor:"yellow", messageTime: 3, allFloors: true, submissive: 50},
		{name: "EnchantedBelt", arousalMode: true, minLevel: 0, weight:4, message:"LootChestEnchantedBelt", messageColor:"yellow", messageTime: 3, allFloors: true, notag: ["NoBelt"], norestraint: ["EnchantedBelt"]},
		{name: "EnchantedBra", arousalMode: true, minLevel: 0, weight:4, message:"LootChestEnchantedBra", messageColor:"yellow", messageTime: 3, allFloors: true, notag: ["NoBelt"], norestraint: ["EnchantedBra"]},
		{name: "EnchantedHeels", minLevel: 0, weight:4, message:"LootChestEnchantedHeels", messageColor:"yellow", messageTime: 3, allFloors: true, norestraint: ["EnchantedHeels"]},
		{name: "EnchantedAnkleCuffs", minLevel: 0, weight:4, message:"LootChestEnchantedAnkleCuffs", messageColor:"yellow", messageTime: 3, allFloors: true, norestraint: ["EnchantedAnkleCuffs", "EnchantedAnkleCuffs2"]},
		{name: "EnchantedBlindfold", minLevel: 3, weight:4, message:"LootChestEnchantedBlindfold", messageColor:"yellow", messageTime: 3, allFloors: true, norestraint: ["EnchantedBlindfold"]},
		{name: "EnchantedMuzzle", minLevel: 0, weight:4, message:"LootChestEnchantedMuzzle", messageColor:"yellow", messageTime: 3, allFloors: true, norestraint: ["EnchantedMuzzle"]},
		{name: "EnchantedMittens", minLevel: 3, weight:4, message:"LootChestEnchantedMittens", messageColor:"yellow", messageTime: 3, allFloors: true, norestraint: ["EnchantedMittens"]},
		{name: "EnchantedArmbinder", minLevel: 5, weight:4, message:"LootChestEnchantedArmbinder", messageColor:"yellow", messageTime: 3, allFloors: true, norestraint: ["EnchantedArmbinder"]},
		{name: "EnchantedBallGag", minLevel: 0, weight:4, message:"LootChestEnchantedBallGag", messageColor:"yellow", messageTime: 3, allFloors: true, norestraint: ["EnchantedBallGag"]},
		{name: "PotionCollar", minLevel: 1, weight:10, message:"LootPotionCollar", messageColor:"yellow", messageTime: 3, allFloors: true, norestraint: ["PotionCollar"]},
		{name: "QuakeCollar", minLevel: 5, weight:1, armor: "QuakeCollar", message:"LootChestArmor", messageColor:"yellow", messageTime: 3, allFloors: true, norestraint: ["QuakeCollar"]},
		...KDEnchantedRestraints,
	],
	"lessergold": [
		...KDGoldArmor, ...KDGoldArmor2,
		{name: "RobeOfChastity", arousalMode: true, minLevel: 0, weight:4, message:"LootChestArmor",
			armor: "RobeOfChastity",
			messageColor:"yellow", messageTime: 3, allFloors: true, norestraint: ["RobeOfChastity"]},

		{name: "scrolls_purity", minLevel: 0, weight: 1, message:"LootChestScrollsPurity", messageColor:"yellow", messageTime: 3, allFloors: true},
		{name: "MistressKey", minLevel: 0, weight:1, message:"LootChestMistressKey", messageColor:"yellow", messageTime: 3, allFloors: true},
		{name: "DivineTear", minLevel: 0, weight:5, message:"LootChestDivineTear", messageColor:"yellow", messageTime: 3, allFloors: true},
		{name: "AncientCores", max: 1, minLevel: 0, weight:3, message:"LootChestAncientCores", messageColor:"yellow", messageTime: 3, allFloors: true},
		{name: "magicknife", minLevel: 0, weight:7, weapon: "EnchKnife", message:"LootChestMagicKnife", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["EnchKnife"]},
		{name: "Scrolls", minLevel: 0, weight:2, message:"LootChestScrolls", messageColor:"yellow", messageTime: 3, allFloors: true},
		//{name: "spell_points", magic: true, minLevel: 3, weight: 3, message:"LootChestSpellPoints", messageColor:KDBaseLightBlue, messageTime: 3, special:100, allFloors: true, max: 1},
		{name: "manaorbmany", minLevel: 0, weight:1, message:"LootManaOrbMany", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "MagicSword", minLevel: 3, weight:0.33, weapon: "MagicSword", message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["MagicSword"]},
		{name: "MagicAxe", minLevel: 3, weight:0.33, weapon: "MagicAxe", message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["MagicAxe"]},
		{name: "MagicSpear", minLevel: 3, weight:0.33, weapon: "MagicSpear", message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["MagicSpear"]},
		{name: "MagicFlail", minLevel: 3, weight:0.33, weapon: "MagicFlail", message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["MagicFlail"]},
		{name: "MagicHammer", minLevel: 3, weight:0.33, weapon: "MagicHammer", message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["MagicHammer"]},
		{name: "IceBreaker", minLevel: 2, weight:0.33, weapon: "IceBreaker", goddess: "Elements", goddessWeight: 3, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["IceBreaker"]},
		{name: "StormBreaker", minLevel: 2, weight:0.33, weapon: "StormBreaker", goddess: "Elements", goddessWeight: 3, message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["StormBreaker"]},
		{name: "DarkKatana", minLevel: 2, weight:0.33, goddess: "Illusion", goddessWeight: 6, weapon: "DarkKatana", message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["DarkKatana"]},
		//{name: "trap_protobelt", arousalMode: true, trap: true, minLevel: 9, goddess: "Metal", goddessWeight: 4, weight:0, message:"LootChestTrapMagicVibe", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemVulvaPiercings"], power: 15},
		{name: "trap_plug2", notag: ["SupremeBelt", "NoBelt"], arousalMode: true, trap: true, minLevel: 6, weight:1.5, message:"LootChestTrapMagicPlug", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemVulva", "alreadyBelted", "vibe"], power: 3},
		{name: "trap_plug2_torment", notag: ["SupremeBelt", "NoBelt"], arousalMode: true, trap: true, lock: "Gold", minLevel: 11, weight:1, message:"LootChestTrapMagicPlug", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemVulva", "alreadyBelted", "vibe"], power: 5},
		{name: "trap_nipple2", notag: ["SupremeBra", "FreeBoob"], arousalMode: true, trap: true, minLevel: 7, weight:4, message:"LootChestTrapMagicNipple", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemNipples", "vibe"], power: 3},
		{name: "PotionCollar", minLevel: 1, weight:1.5, message:"LootPotionCollar", messageColor:"yellow", messageTime: 3, allFloors: true, norestraint: ["PotionCollar"]},
		{name: "SarielPanties", armor: "SarielPanties", minLevel: 1, weight:1.2, message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, norestraint: ["SarielPanties"]},
	],
	"silver": [
		{name: "EssenceNecklace", minLevel: 1, weight:10, message:"LootEssenceNecklace",
			armor: "EssenceNecklace",
			messageColor:"yellow", messageTime: 3, allFloors: true, norestraint: ["EssenceNecklace"]},
		{name: "manaorb", minLevel: 0, weight:4, message:"LootManaOrb", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "biggold", minLevel: 0, weight:10, message:"LootChestGold", messageColor:"#e7cf1a", messageTime: 3, allFloors: true},
		{name: "magicknife", minLevel: 0, weight:2.5, weapon: "EnchKnife", message:"LootChestMagicKnife", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, noweapon: ["EnchKnife"]},
		{name: "MagicRope", arousalMode: true, minLevel: 0, weight:4, weapon: "MagicRope", noweapon: ["MagicRope"], message:"LootChestWeapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "scrolls_basic", minLevel: 0, weight: 1.75, message:"LootChestScrollsBasic", messageColor:"yellow", messageTime: 3, allFloors: true},
		{name: "scrolls_purity", minLevel: 0, weight: 0.75, message:"LootChestScrollsPurity", messageColor:"yellow", messageTime: 3, allFloors: true},
		/*{name: "trap_armbinderHeavy", trap:true, minLevel: 5, weight:2, message:"LootChestTrapMagicHarness", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemArms", "ModerateRestraint"], power: 6},
		{name: "trap_harness", trap: true, minLevel: 1, weight:2, message:"LootChestTrapMagic", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemTorso"], power: 4},
		{name: "trap_gagHeavy", trap:true, minLevel: 3, weight:3, message:"LootChestTrapMagic", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemMouth2"], power: 10},
		{name: "trap_mithrilankle", trap:true, minLevel: 4, weight:3, message:"LootChestTrapMagic", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemFeet"], power: 18},
		{name: "trap_beltonly", arousalMode: true, trap: true, minLevel: 1, weight:2, message:"LootChestTrapMagicBelt", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemPelvis"], power: 5},
		{name: "trap_belt", arousalMode: true, trap: true, minLevel: 3, weight:2, message:"LootChestTrapMagicVibe", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemVulvaPiercings", "alreadyBelted"], power: 1},
		*/
		{name: "trap_plug", notag: ["SupremeBelt", "NoBelt"], arousalMode: true, trap: true, minLevel: 5, weight:1.5, message:"LootChestTrapMagicPlug", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemVulva", "alreadyBelted", "vibe"], power: 3},
		{name: "trap_plug_tease", notag: ["SupremeBelt", "NoBelt"], arousalMode: true, trap: true, minLevel: 11, weight:1, message:"LootChestTrapMagicPlug", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemVulva", "alreadyBelted", "vibe"], power: 4},
		{name: "trap_plug_torment", notag: ["SupremeBelt", "NoBelt"], arousalMode: true, trap: true, minLevel: 15, weight:0.5, message:"LootChestTrapMagicPlug", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemVulva", "alreadyBelted", "vibe"], power: 5},
		{name: "trap_plug_thunder", notag: ["SupremeBelt", "NoBelt"], arousalMode: true, trap: true, minLevel: 15, weight:0.5, message:"LootChestTrapMagicPlug", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemVulva", "alreadyBelted", "vibe"], power: 5},
		{name: "trap_nipple", notag: ["SupremeBra", "FreeBoob"], arousalMode: true, trap: true, minLevel: 2, weight:2, message:"LootChestTrapMagicNipple", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemNipples", "vibe"], power: 3},
		//{name: "trap_mitts", trap: true, minLevel: 5, weight:2, message:"LootChestTrapMagic", messageColor:KDBaseRed, messageTime: 3, allFloors: true, prerequisites: ["Group_ItemHands", "LightRestraint"], power: 10},
		{name: "potions_mana", minLevel: 0, weight:3, message:"LootPotionsMana", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, prerequisites: ["lowmanapotions"]},
		{name: "potions_will", minLevel: 0, weight:2, message:"LootPotionsWill", messageColor:"#ff4444", messageTime: 3, allFloors: true, prerequisites: ["lowwillpotions"]},
		{name: "potions_many", minLevel: 1, weight:2, message:"LootPotionsMedley", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, prerequisites: ["lowpotions"]},
		{name: "grinder", minLevel: 1, weight:2, message:"LootChestGrinder", messageColor:"yellow", messageTime: 3, allFloors: true},
		{name: "PotionCollar", minLevel: 1, weight:0.5, message:"LootPotionCollar", messageColor:"yellow", messageTime: 3, allFloors: true, norestraint: ["PotionCollar"]},
		{name: "SlimeWalkers", armor: "SlimeWalkers", minLevel: 1, weight:0.5, message:"LootSlimeWalkers", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, norestraint: ["SlimeWalkers"]},
		{name: "ElvenPanties", armor: "ElvenPanties", minLevel: 1, weight:1, message:"LootChestArmor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, norestraint: ["ElvenPanties"]},
		...KDAdvancedArmor, ...KDSilverArmor,
	],


	RopeQuest: [
		{name: "spell_points", magic: true, minLevel: 0, weight:4, message:"KDGoddessQuestReward_SpellPoints", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, max: 1},
		{name: "StaffBind", minLevel: 0, weight:5, weapon: "StaffBind", noweapon: ["StaffBind"], message:"KDGoddessQuestReward_Weapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "BindingDress", minLevel: 0, weight: 10,
			armor: "BindingDress",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			cursesuffix: "",
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "DressMuzzle", minLevel: 0, weight: 10,
			armor: "DressMuzzle",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			cursesuffix: "",
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "DressBra", minLevel: 0, weight: 10,
			armor: "DressBra",
			amtMult: 1,
			maxEnchants: 3,
			minEnchants: 2,
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			cursesuffix: "",
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "TrapPlug", minLevel: 0, weight: 3, arousalMode: true,
			armor: "TrapPlug",
			amtMult: 1,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "TrapPlug2", minLevel: 0, weight: 3, arousalMode: true,
			armor: "TrapPlug2",
			amtMult: 1,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "TrapPlug3", minLevel: 0, weight: 3, arousalMode: true,
			armor: "TrapPlug3",
			amtMult: 1,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "TrapVibeProto", minLevel: 0, weight: 3, arousalMode: true,
			armor: "TrapVibeProto",
			amtMult: 1.5,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		...KDGoldArmorGoddess, ...KDGoldArmor2Goddess,
	],
	LatexQuest: [
		{name: "spell_points", magic: true, minLevel: 0, weight:4, message:"KDGoddessQuestReward_SpellPoints", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, max: 1},
		{name: "SlimeWalkers", armor: "SlimeWalkers", minLevel: 0, weight:10, message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, norestraint: ["SlimeWalkers"]},
		{name: "Corset", minLevel: 0, weight: 10,
			armor: "LatexCorset",
			amtMult: 1,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "LatexCatsuit", minLevel: 0, weight: 10,
			armor: "LatexCatsuit",
			amtMult: 1,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "LatexHeels", minLevel: 0, weight: 10,
			armor: "LatexBoots",
			amtMult: 1,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "LatexStraitjacket", minLevel: 0, weight: 10,
			armor: "LatexStraitjacket",
			amtMult: 2,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "LatexBoxbinder", minLevel: 0, weight: 10,
			armor: "LatexBoxbinder",
			amtMult: 2,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "LatexArmbinder", minLevel: 0, weight: 10,
			armor: "LatexArmbinder",
			amtMult: 2,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "NeckCorset", minLevel: 0, weight: 10,
			armor: "ExpCollar",
			amtMult: 2,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		...KDGoldArmorGoddess, ...KDGoldArmor2Goddess,
	],
	LeatherQuest: [
		{name: "spell_points", magic: true, minLevel: 0, weight:4, message:"KDGoddessQuestReward_SpellPoints", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, max: 1},
		{name: "StaffDoll", minLevel: 0, weight: 8, weapon: "StaffDoll", noweapon: ["StaffDoll"], message:"KDGoddessQuestReward_Weapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "LeatherArmCuffs", minLevel: 0, weight: 7,
			armor: "LeatherArmCuffs",
			amtMult: 1,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "LeatherAnkleCuffs", minLevel: 0, weight: 7,
			armor: "LeatherAnkleCuffs",
			amtMult: 1,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "LeatherLegCuffs", minLevel: 0, weight: 7,
			armor: "LeatherLegCuffs",
			amtMult: 1,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Armbinder", minLevel: 0, weight: 10,
			armor: "HighsecArmbinder",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Boxbinder", minLevel: 0, weight: 10,
			armor: "HighsecBoxbinder",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Straitjacket", minLevel: 0, weight: 10,
			armor: "HighsecStraitjacket",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "Legbinder", minLevel: 0, weight: 10,
			armor: "HighsecLegbinder",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "ScaleArmbinder", minLevel: 0, weight: 10,
			armor: "DragonArmbinder",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		...KDGoldArmorGoddess, ...KDGoldArmor2Goddess,
	],
	MetalQuest: [
		{name: "spell_points", magic: true, minLevel: 0, weight:4, message:"KDGoddessQuestReward_SpellPoints", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, max: 1},
		{name: "Blaster", minLevel: 0, weight:5, weapon: "Blaster", noweapon: ["Blaster"], message:"KDGoddessQuestReward_Weapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "MistressKey", minLevel: 0, weight:5, message:"KDGoddessQuestReward_MistressKey", messageColor:"yellow", messageTime: 3, allFloors: true},
		{name: "DollJacket", minLevel: 0, weight: 10,
			armor: "CyberDollJacket",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "HeavyYoke", minLevel: 0, weight: 10,
			armor: "HeavyYoke",
			amtMult: 2,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "HeavyYoke", minLevel: 0, weight: 4,
			armor: "HeavyYoke",
			amtMult: 2,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "TrapFiddle", minLevel: 0, weight: 4,
			armor: "TrapFiddle",
			amtMult: 2,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "CyberDoll", minLevel: 0, weight: 40,
			armortags: ["cyberDollRestraints"], armor: "ControlHarness",
			amtMult: 1.75,
			maxEnchants: 3,
			cursesuffix: "",
			faction: "Curse",
			enchantlist: "Gold", enchantchance: 1,
			unlockcurse: ["Divine"], enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "ControlHarness", minLevel: 0, weight: 10,
			armor: "ControlHarness",
			amtMult: 2.5,
			maxEnchants: 2,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "CyberBallGag", minLevel: 0, weight: 10,
			armor: "CyberBallGag",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "CyberMuzzle", minLevel: 0, weight: 10,
			armor: "CyberMuzzle",
			amtMult: 2,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "WolfPetsuit", minLevel: 0, weight: 10,
			armor: "WolfPetsuit",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			prerequisites: ["nopetsuit"],
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "CyberBelt", minLevel: 0, weight: 4,
			armor: "CyberBelt", arousalMode: true,
			amtMult: 1.5,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "TrapBelt", minLevel: 0, weight: 4,
			armor: "TrapBelt", arousalMode: true,
			amtMult: 1.5,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "WolfPanties", minLevel: 0, weight: 4,
			armor: "WolfPanties", arousalMode: true,
			amtMult: 1.5,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "TrapBra", minLevel: 0, weight: 4,
			armor: "TrapBra", arousalMode: true,
			amtMult: 1.5,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "TrapBra2", minLevel: 0, weight: 4,
			armor: "TrapBra2", arousalMode: true,
			amtMult: 1.5,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "TrapBeltProto", minLevel: 0, weight: 4,
			armor: "TrapBeltProto", arousalMode: true,
			amtMult: 1.5,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		...KDGoldArmorGoddess, ...KDGoldArmor2Goddess,
	],
	WillQuest: [
		{name: "spell_points", magic: true, minLevel: 0, weight:4, message:"KDGoddessQuestReward_SpellPoints", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, max: 1},
		{name: "PotionCollar", armor: "PotionCollar", minLevel: 0, weight:10, message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, norestraint: ["PotionCollar"]},
		{name: "Petsuit", minLevel: 0, weight: 10,
			armor: "KittyPetSuit",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			prerequisites: ["nopetsuit"],
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},


		{name: "MikoDress", minLevel: 0, weight: 10,
			armor: "MikoDress",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "MikoGag", minLevel: 0, weight: 10,
			armor: "MikoGag",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		...KDGoldArmorGoddess, ...KDGoldArmor2Goddess,
	],
	ElementsQuest: [
		{name: "spell_points", magic: true, minLevel: 0, weight:4, message:"KDGoddessQuestReward_SpellPoints", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, max: 1},
		{name: "IceBreaker", minLevel: 0, weight:3, weapon: "IceBreaker", message:"KDGoddessQuestReward_Weapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["IceBreaker"]},
		{name: "StormBreaker", minLevel: 0, weight:3, weapon: "StormBreaker", message:"KDGoddessQuestReward_Weapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["StormBreaker"]},
		{name: "ChastityBelt", minLevel: 0, weight: 10,
			armor: "BlacksteelBelt",
			arousalMode: true,
			amtMult: 2,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "TrapBelt2", minLevel: 0, weight: 4, arousalMode: true,
			armor: "TrapBelt2",
			amtMult: 1.5,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "TrapPlug", minLevel: 0, weight: 3, arousalMode: true,
			armor: "TrapPlug",
			amtMult: 1,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			prerequisites: ["nofrontplug"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "TrapPlug2", minLevel: 0, weight: 3, arousalMode: true,
			armor: "TrapPlug2",
			amtMult: 1,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			prerequisites: ["nofrontplug"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "TrapPlug3", minLevel: 0, weight: 3, arousalMode: true,
			armor: "TrapPlug3",
			amtMult: 1,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			prerequisites: ["nofrontplug"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "TrapPlug4", minLevel: 0, weight: 2, arousalMode: true,
			armor: "TrapPlug4",
			amtMult: 0.75,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			prerequisites: ["nofrontplug"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "TrapPlug5", minLevel: 0, weight: 1, arousalMode: true,
			armor: "TrapPlug5",
			amtMult: 1,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			prerequisites: ["nofrontplug"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "StaffIncineration", minLevel: 0, weight:5, weapon: "StaffIncineration", noweapon: ["StaffIncineration"], message:"KDGoddessQuestReward_Weapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "StaffStorm", minLevel: 0, weight:5, weapon: "StaffStorm", noweapon: ["StaffStorm"], message:"KDGoddessQuestReward_Weapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "StaffFrostbite", minLevel: 0, weight:5, weapon: "StaffFrostbite", noweapon: ["StaffFrostbite"], message:"KDGoddessQuestReward_Weapon", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		...KDGoldArmorGoddess, ...KDGoldArmor2Goddess,

	],
	ConjureQuest: [
		{name: "spell_points", magic: true, minLevel: 0, weight:4, message:"KDGoddessQuestReward_SpellPoints", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, max: 1},

		{name: "BallGag", minLevel: 0, weight: 10,
			armor: "HighsecBallGag",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "ComfyStraitjacket", minLevel: 0, weight: 10,
			armor: "ComfyStraitjacket",
			amtMult: 2,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "ComfyGag", minLevel: 0, weight: 10,
			armor: "ComfyGag",
			amtMult: 1.5,
			maxEnchants: 3,
			minEnchants: 1,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "MagicHammer", minLevel: 0, weight:3, weapon: "MagicHammer", message:"KDGoddessQuestReward_Weapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["MagicHammer"]},
		{name: "MagicSword", minLevel: 0, weight:3, weapon: "MagicSword", message:"KDGoddessQuestReward_Weapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["MagicSword"]},
		{name: "MagicFlail", minLevel: 0, weight:3, weapon: "MagicFlail", message:"KDGoddessQuestReward_Weapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["MagicFlail"]},
		{name: "MagicSpear", minLevel: 0, weight:3, weapon: "MagicSpear", message:"KDGoddessQuestReward_Weapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["MagicSpear"]},
		{name: "MagicAxe", minLevel: 0, weight:3, weapon: "MagicAxe", message:"KDGoddessQuestReward_Weapon", messageColor:KDBaseLightBlue, messageTime: 3,
			allFloors: true, noweapon: ["MagicAxe"]},
		...KDGoldArmorGoddess, ...KDGoldArmor2Goddess,
	],
	IllusionQuest: [
		{name: "Blindfold", minLevel: 0, weight: 10,
			armor: "TrapBlindfold",
			amtMult: 2,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			prerequisites: ["noblindfold"],
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "InvisibleBlindfold", minLevel: 0, weight: 10,
			armor: "InvisibleBlindfold",
			amtMult: 1,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "KiguMask", minLevel: 0, weight: 10,
			armor: "KiguMask",
			amtMult: 1,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			prerequisites: ["nokigu"],
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "MaidDress", minLevel: 0, weight: 10,
			armor: "MaidDress",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "ShadowLatexLegbinder", minLevel: 0, weight: 10,
			armor: "ShadowLatexLegbinder",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},
		{name: "ShadowLatexStraitjacket", minLevel: 0, weight: 10,
			armor: "ShadowLatexStraitjacket",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "ShadowLatexBoxbinder", minLevel: 0, weight: 10,
			armor: "ShadowLatexBoxbinder",
			amtMult: 2.5,
			maxEnchants: 4,
			minEnchants: 2,
			cursesuffix: "",
			noForceEquip: true,
			unlockcurse: ["Divine"],
			cursechance: 0.25, cursescale: 0.5,
			enchantlist: "Gold", enchantchance: 1,
			enchantlevelmin: 0, enchantlevelmax: 20,
			message:"KDGoddessQuestReward_Armor", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true},

		{name: "spell_points", magic: true, minLevel: 0, weight:4, message:"KDGoddessQuestReward_SpellPoints", messageColor:KDBaseLightBlue, messageTime: 3, allFloors: true, max: 1},
		{name: "DivineTear", minLevel: 0, weight:5, message:"KDGoddessQuestReward_Macaron", messageColor:"yellow", messageTime: 3, allFloors: true},
		...KDGoldArmorGoddess, ...KDGoldArmor2Goddess,
	],
};


type lootEventFunc = (Loot: any, Floor: number, Replacemsg: string, Lock: string, container?: KDContainer) => { value: number; Replacemsg: string };

let KDLootEvents: Record<string, lootEventFunc> = {
	"Armor": (_Loot, _Floor, Replacemsg, _Lock, container) => {
		return {
			value: 0,
			Replacemsg: Replacemsg,
		};
	},
	"archerykit": (_Loot, _Floor, Replacemsg, _Lock, container) => {
		KDInvAddWeapon(container, "Bow");
		KDAddConsumable("AncientPowerSource", 1, container);
		return {
			value: 0,
			Replacemsg: Replacemsg,
		};
	},
};

interface KDMinorLootEntry {
	rarity: number,
	options: any[],
}

let KDMinorLootTable = {
	chest: {
		rarity: 1,
		extraQuantity: 0,
		options: [
			{name: "Knife", minLevel: 0, weight:5, allFloors: true, message:"", messageColor:""},
			{name: "Pick", minLevel: 0, weight:5, quantity: 1, extraQuantity: 2, allFloors: true, message:"", messageColor:""},
			{name: "RedKey", minLevel: 0, weight:3, quantity: 1, extraQuantity: 1, allFloors: true, message:"", messageColor:""},
			{name: "Bomb", minLevel: 0, weight:5, quantity: 1, allFloors: true, message:"", messageColor:""},
			{name: "FlashBomb", minLevel: 0, weight:4, quantity: 1, allFloors: true, message:"", messageColor:""},
			{name: "SmokeBomb", minLevel: 0, weight:5, quantity: 2, allFloors: true, message:"", messageColor:""},
			{name: "Flashbang", minLevel: 0, weight:0.25, quantity: 1, allFloors: true, message:"", messageColor:""},
			{name: "PotionMana", minLevel: 0, weight:3, quantity: 1, allFloors: true, message:"", messageColor:""},
			{name: "PotionStamina", minLevel: 0, weight:3, quantity: 1, allFloors: true, message:"", messageColor:""},
			{name: "PotionWill", minLevel: 0, weight:2, quantity: 1, allFloors: true, message:"", messageColor:""},
			{name: "PotionFrigid", minLevel: 0, weight:2, quantity: 1, allFloors: true, message:"", messageColor:""},
			{name: "Gunpowder", minLevel: 0, weight:2, quantity: 1, allFloors: true, message:"", messageColor:""},
		],
	},
}